import { render } from "./LegalPageShell.vue?vue&type=template&id=73395e18"
import script from "./LegalPageShell.vue?vue&type=script&lang=js"
export * from "./LegalPageShell.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__